export enum SPECIFIC_SERVICE_ALIAS {
  POTENTIAL = 'potential',
  UPCOMING = 'upcoming',
  HISTORY = 'history',
}
